module.exports = __webpack_public_path__ + "66c76036edf7169fa78ef59f585a9719.gif";